import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, Clock } from 'lucide-react';
import { placements } from '../data/mock';

const LiveTicker = () => (
  <motion.div
    initial={{ opacity: 0, y: 20 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ delay: 1.8, duration: 0.7 }}
    className="relative z-10 border-t border-white/10 bg-white/[0.03] backdrop-blur-sm overflow-hidden"
    data-testid="live-ticker"
  >
    <div className="max-w-7xl mx-auto flex items-stretch">
      <div className="shrink-0 flex items-center gap-2 px-5 lg:px-8 py-3.5 bg-obsidian border-r border-white/10 z-10">
        <span className="relative flex h-2 w-2"><span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-75" /><span className="relative inline-flex rounded-full h-2 w-2 bg-emerald-400" /></span>
        <span className="text-[11px] font-bold uppercase tracking-[0.2em] text-slate-300 whitespace-nowrap">Zuletzt besetzt</span>
      </div>
      <div className="relative flex-1 overflow-hidden">
        <div className="absolute left-0 inset-y-0 w-16 bg-gradient-to-r from-[#0B0A12] to-transparent z-10" />
        <div className="absolute right-0 inset-y-0 w-16 bg-gradient-to-l from-[#0B0A12] to-transparent z-10" />
        <div className="marquee-track items-center h-full" style={{ animationDuration: '55s' }}>
          {[...placements, ...placements].map((p, i) => (
            <div key={i} className="flex items-center gap-3 px-8 py-3.5 text-sm whitespace-nowrap" data-testid={i < placements.length ? `ticker-item-${i}` : undefined}>
              <CheckCircle2 className="w-4 h-4 text-emerald-400 shrink-0" />
              <span className="text-white font-semibold">{p.role}</span>
              <span className="text-slate-500">·</span>
              <span className="text-slate-300">{p.city}</span>
              <span className="text-slate-500">·</span>
              <span className="inline-flex items-center gap-1 text-amber-300 font-medium"><Clock className="w-3.5 h-3.5" /> {p.time}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  </motion.div>
);

export default LiveTicker;
